export enum InsuredDrawerParams {
  InsuredId = 'insuredId',
  ClaimSetNumber = 'claimSetNumber',
  Highlight = 'highlight',
  Expanded = 'expanded',
}
